package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_travelagent_data_di_TravelAgentModule : Module get() = module {
	single() { _ -> com.essntl.features.travelagent.data.repository.TravelAgentRepositoryImpl(supabase=get()) } bind(com.essntl.features.travelagent.domain.repository.TravelAgentRepository::class)
	single() { _ -> com.essntl.features.travelagent.data.supabase.TravelAgentSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.travelagent.data.supabase.TravelAgentSupabaseDataSource::class)
}
public val com.essntl.features.travelagent.data.di.TravelAgentModule.module : org.koin.core.module.Module get() = com_essntl_features_travelagent_data_di_TravelAgentModule
